import React ,{useState} from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Button,
} from "@mui/material";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';


const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#1976d2',
      },
    },
  });
export default function BookingHeader(props) {
    const [openDrawer, setOpenDrawer] = useState(false);
    const HandelLoginFlag=(event)=>{
       // if (!flag){
      
          props.changeLoginFlag(true)
       // }
      }
      const toggleDrawer = () => {
        setOpenDrawer(!openDrawer);
      };
    
    return (
        <>
                <ThemeProvider theme={darkTheme}>
        <AppBar position="fixed">
        <Toolbar>
           
        <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawer}
          >
            <MenuIcon />
  
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Booking
          </Typography>
          <Button    onClick={()=>HandelLoginFlag()} color="inherit">Login</Button>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer}>
        <List sx={{ width: 250 }}>

          <ListItemButton>
            <ListItemText primary="Home" onClick={()=>props.changeMyMenu(0)} />
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Profile"  onClick={()=>props.changeMyMenu(1)} />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Report"  onClick={()=>props.changeMyMenu(2)}/>
              </ListItemButton>
          {/* <ListItemButton onClick={handleSubMenu}>
            <ListItemText primary="Products" />
            {openSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Add Product" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Product List" />
              </ListItemButton>
            </List>
          </Collapse> */}

        </List>
      </Drawer>
        </ThemeProvider>
        </>
        )

}